import { Alert, Card, FlyerPreview, Loading } from '@avrahami/ui';
import { useQuery } from '@tanstack/react-query';
import { productFlyerQuery } from '../api/tenant';
import { he } from '../i18n/he';
import { errorMessage } from '../lib/forms';
import { mediaUrl } from '../lib/media';

/**
 * The product's marketing flyer (docs/FLYERS.md): the image the store downloads and shares. It is
 * the flyer of the store's template, in the store's colours and logo, drawn from the product's
 * page in the store each time it is shown.
 */
export function FlyerCard({ productId }: { productId: string }) {
  const flyer = useQuery(productFlyerQuery(productId));
  return (
    <Card title={he.flyer.title}>
      <div className="flex flex-col gap-3" data-testid="product-flyer">
        <p className="text-sm text-slate-600">{he.flyer.intro}</p>
        {flyer.isPending ? <Loading /> : null}
        {flyer.isError ? <Alert>{errorMessage(flyer.error)}</Alert> : null}
        {flyer.data === undefined ? null : (
          <>
            <FlyerPreview flyer={flyer.data} mediaUrl={mediaUrl} words={he.flyer} />
            {flyer.data.price === null ? (
              <p className="text-xs text-slate-500">{he.flyer.noPrice}</p>
            ) : null}
          </>
        )}
      </div>
    </Card>
  );
}
